import React from 'react';
import './Features.css';

const featureCards = [
  {
    eyebrow: 'Personalized Learning',
    title: 'Structured paths for every learner',
    description: 'Clear course journeys, guided lessons, and focused outcomes designed for steady progress.',
    accent: 'gold',
    stat: '01',
    points: ['Step-by-step modules', 'Goal-based learning flow']
  },
  {
    eyebrow: 'Live + Recorded',
    title: 'Learn anytime with expert guidance',
    description: 'Blend live classes, recorded sessions, and revision-friendly content in one learning experience.',
    accent: 'blue',
    stat: '24/7',
    points: ['Flexible access', 'Expert-led sessions']
  },
  {
    eyebrow: 'Student Support',
    title: 'Doubt solving that keeps momentum',
    description: 'Quick support, practical guidance, and learner-first assistance to help students stay on track.',
    accent: 'peach',
    stat: '100%',
    points: ['Mobile-friendly access', 'Continuous assistance']
  }
];

function Features() {
  return (
    <section className="features">
      <div className="container">
        <h2 className="section-title">
          Why Modern <span className="highlight">EdTech</span><br />
          Needs Better Learning Design
        </h2>
        
        <div className="features-grid">
          {featureCards.map((feature) => (
            <div className={`feature-card ${feature.accent}`} key={feature.title}>
              <div className="feature-top">
                <span className="feature-eyebrow">{feature.eyebrow}</span>
                <span className="feature-stat">{feature.stat}</span>
              </div>
              <div className="feature-body">
                <h3 className="feature-title">{feature.title}</h3>
                <p className="feature-description">{feature.description}</p>
              </div>
              <div className="feature-points">
                {feature.points.map((point) => (
                  <span className="feature-point" key={point}>{point}</span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Features;
